import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SafeUrl } from '@angular/platform-browser';
import { Icon, ICONS } from '@nimbus-library/features/shared/resources/icons';
import { isValidPhoneNumber } from '@nimbus-library/features/shared/components/material/core';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';

@Component({
  standalone: false,
  selector: 'nimbus-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent implements OnChanges {
  @Input() public imageSrc: SafeUrl | string;
  @Input() public name: string;
  @Input() public initials: string;
  @Input() public customIcon: Icon | undefined;

  public showImage: boolean | undefined;
  public isImageLoading: boolean = false;

  private get isValidPhoneNumber(): boolean {
    return this.name && isValidPhoneNumber(this.name);
  }

  private get isAnonymousCaller(): boolean {
    return this.name && this.translateService.instant(this.name) === this.translateService.instant(TranslationKeys.GeneralAnonymous);
  }

  public get icon(): Icon | undefined {
    return this.customIcon || (this.isValidPhoneNumber ? ICONS.PHONE_LIGHT : this.isAnonymousCaller ? ICONS.ANONYM_LIGHT : undefined);
  }

  public get isIconDisplayed(): boolean {
    return this.isValidPhoneNumber || this.isAnonymousCaller || !!this.customIcon;
  }

  public constructor(private readonly translateService: TranslateService) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.imageSrc) {
      this.showImage = !!this.imageSrc;
      if (this.showImage) {
        this.isImageLoading = true;
      }
    }
  }

  public onLoad(): void {
    this.showImage = true;
    this.isImageLoading = false;
  }

  public onError(): void {
    this.showImage = false;
    this.isImageLoading = false;
  }
}
